import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconCircularArrowWithDotGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M14.4429 12.9973C14.4429 11.8973 13.5429 10.9973 12.4429 10.9973C11.3429 10.9973 10.4429 11.8973 10.4429 12.9973C10.4429 14.0973 11.3429 14.9973 12.4429 14.9973C13.5429 14.9973 14.4429 14.0973 14.4429 12.9973ZM12.4429 3.99731C7.47287 3.99731 3.44287 8.02731 3.44287 12.9973H0.442871L4.44287 16.9973L8.44287 12.9973H5.44287C5.44287 9.12731 8.57287 5.99731 12.4429 5.99731C16.3129 5.99731 19.4429 9.12731 19.4429 12.9973C19.4429 16.8673 16.3129 19.9973 12.4429 19.9973C10.9329 19.9973 9.53287 19.5073 8.38287 18.6973L6.96287 20.1373C8.48287 21.2973 10.3829 21.9973 12.4429 21.9973C17.4129 21.9973 21.4429 17.9673 21.4429 12.9973C21.4429 8.02731 17.4129 3.99731 12.4429 3.99731Z"
        fill={fillColor}
      />
    </g>
  );
};

export const IconCircularArrowWithDotSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...(props.svg ?? {})}
    >
      <IconCircularArrowWithDotGroup {...props} />
    </svg>
  );
};
